import * as React from 'react';

export const ContentContext = React.createContext();

export const ShowContentManageClassProvider = ({ children }) => {
  const [showContentManageClass, setShowContentManageClass] =
    React.useState(false);

  const [updateClasses, setUpdateClasses] = React.useState(false);
  const [showManagerRegional, setShowManageRegional] = React.useState(false);
  return (
    <ContentContext.Provider
      value={{
        showContentManageClass,
        setShowContentManageClass,
        updateClasses,
        setUpdateClasses,
        showManagerRegional,
        setShowManageRegional,
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};
